// extracted by mini-css-extract-plugin
export default {"e3dVoipContainer":"dcc_e3dVoip-e3dVoipContainer"};